var render = function render(_c,_vm){return _c('div',{staticClass:"create-campaign-cg-elite-badge"},[_vm._v(" CG members only ")])
}
var staticRenderFns = []

export { render, staticRenderFns }